const SensorTile = ({ label, value, unit, Icon, bg, color }) => (
  <div className="flex items-center space-x-3">
    <div className={`p-2 ${bg} rounded-lg`}>
      <Icon className={`w-4 h-4 ${color}`} />
    </div>
    <div>
      <p className="text-xs text-gray-500">{label}</p>
      <p className="font-semibold">{value != null ? `${value} ${unit}` : "N/A"}</p>
    </div>
  </div>
);

export default SensorTile;